export const giveawayPickerSteps = [
    { id: 1, name: 'steps.select_account' },
    { id: 2, name: 'steps.select_post' },
    { id: 3, name: 'steps.chose_options' },
    { id: 4, name: 'steps.pick_winner' }
] as const;

export type StepType = (typeof giveawayPickerSteps)[number];
